<style>
    table, th, td{
         border: solid 1px rgba(40,40,40,0.2);
         font-size:14px;
         padding:5px;
     }
     table{
         width: 100%;
     }
 </style>
<div class="row">
    <div class="col-12">
        <h2>Geles Rígidos</h2>
    </div>
    <div class="col-12">
        <table id="myTable">
            <tr class="header">
              <th style="width:50%;"><t1>Artículo</t1></th>
              <th style="width:10%;"><t1>Código</t1></th>
              <th style="width:40%;"><t1>Medidas</t1></th>
            </tr>
            <tr>
              <td><t2>Gel Rígido x 170g</t2></td>
              <td><t2>GR001</t2></td>
              <td><t2>Largo:9 cm, Ancho: 7 cm</t2></td>
            </tr>
            <tr>
              <td><t2>Gel Rígido x 550g</t2></td>
              <td><t2>GR002</t2></td>
              <td><t2>Largo:18,5 cm, Ancho: 11,5 cm</t2></td>
            </tr>
          </table>
    </div>
</div>